import { createCheckoutI18n, DEFAULT_LOCALE, resolveLocale } from '@gig/checkout-shared-i18n';
import type { I18nMessages } from '@gig/checkout-shared-i18n';
import { __ENV__ } from '../api/constant.js';

const I18N_APP_MODULE = 'cashier';

export const checkoutI18n = createCheckoutI18n({
  modules: [I18N_APP_MODULE],
  initialLocale: DEFAULT_LOCALE,
  env: __ENV__,
  localLanguages: ['en'],
  loadLocalModuleMessages: async (moduleName: string, language: string) => {
    try {
      return (await import(`./modules/${moduleName}/${language}.json`)).default as I18nMessages;
    } catch {
      return {};
    }
  },
});

export const ensureI18nReady = checkoutI18n.ensureI18nReady;

export const t = checkoutI18n.t;

export const getLocale = checkoutI18n.getLocale;

export const setLocale = checkoutI18n.setLocale;

export const onLocaleChange = checkoutI18n.onLocaleChange;

export const resolveCheckoutLocale = resolveLocale;

void ensureI18nReady();
